import React from 'react';
import { Route } from 'react-router-dom';
import lazyLoad from 'utils/lazyLoad';
import useFeatureToggle from 'hooks/useFeatureToggle';
import { getRouterPath } from 'utils/navigation';

const IncidentTypes = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "IncidentTypes" */ 'pages/IncidentManagement/IncidentTypes'
    ),
);
const IncidentTypeDetails = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "IncidentTypeDetails" */ 'pages/IncidentManagement/IncidentTypeDetails'
    ),
);

export default function useIncidentTypesRoutes() {
  const isIncidentTypesEnabled = useFeatureToggle('INCIDENT_TYPES');

  if (!isIncidentTypesEnabled) {
    return [];
  }

  return [
    <Route
      exact
      path={getRouterPath('/incidents/incident-types')}
      component={IncidentTypes}
    />,
    <Route
      path={getRouterPath('/incidents/incident-types/:incidentTypeUuid')}
      component={IncidentTypeDetails}
    />,
  ];
}
